// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__3eQAr","proceedButton":"styles_proceedButton__281my","button":"styles_button__3WC6m"};